import { render, staticRenderFns } from "./ChamberOfCommerceAmount.vue?vue&type=template&id=5fbfd709&scoped=true"
import script from "./ChamberOfCommerceAmount.vue?vue&type=script&lang=js"
export * from "./ChamberOfCommerceAmount.vue?vue&type=script&lang=js"
import style0 from "./ChamberOfCommerceAmount.vue?vue&type=style&index=0&id=5fbfd709&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fbfd709",
  null
  
)

export default component.exports